import { render, staticRenderFns } from "./VehicleAccessories.vue?vue&type=template&id=0fb83bc0&scoped=true"
import script from "./VehicleAccessories.vue?vue&type=script&lang=js"
export * from "./VehicleAccessories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb83bc0",
  null
  
)

export default component.exports